import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import Attribute from 'models/CompetitionMap/Attribute';
import { axiosBaseQuery } from 'services/api';
import { byId } from 'store/utils/sortFunctions';

// Tags for cache invalidation
export const ATTRIBUTE_TAG = 'Attribute';

export const attributeApi = createApi({
  reducerPath: 'attributeApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/',
  }),
  tagTypes: [ATTRIBUTE_TAG],
  endpoints: builder => ({
    // Get list of attributes
    listAttributes: builder.query({
      query: ({ project, product }) => ({
        url: `projects/${project}/products/${product}/attributes/`,
      }),
      transformResponse: data => List(data.map(attribute => new Attribute(attribute))).sort(byId),
      providesTags: [ATTRIBUTE_TAG],
    }),

    // Fetch single attribute
    fetchAttribute: builder.query({
      query: ({ project, product, id }) => ({
        url: `projects/${project}/products/${product}/attributes/${id}/`,
      }),
      transformResponse: data => new Attribute(data),
    }),

    // Create attribute
    createAttribute: builder.mutation({
      query: ({ project, product, ...data }) => ({
        url: `projects/${project}/products/${product}/attributes/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [ATTRIBUTE_TAG],
    }),

    // Update attribute
    updateAttribute: builder.mutation({
      query: ({ project, product, attributeId, ...data }) => ({
        url: `projects/${project}/products/${product}/attributes/${attributeId}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [ATTRIBUTE_TAG],
    }),

    // Delete attribute
    deleteAttribute: builder.mutation({
      query: ({ project, product, attributeId }) => ({
        url: `projects/${project}/products/${product}/attributes/${attributeId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [ATTRIBUTE_TAG],
    }),
  }),
});

export const {
  useListAttributesQuery,
  useFetchAttributeQuery,
  useCreateAttributeMutation,
  useUpdateAttributeMutation,
  useDeleteAttributeMutation,
} = attributeApi;
